define((require) => {
    "use strict";

    var TextWidgetModel = require("shared/ui/experience/widgets/textWidget/TextWidgetModel");

    /**
     * @class {TextWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return TextWidgetModel.mixin("TextWidgetModelEditorMixin", {
        /**
         * Returns the text value without html attributes
         *
         * @return {string} The stripped text value
         */
        _stripHtmlText() {
            const tmp = document.createElement("DIV");
            tmp.innerHTML = this.get("text");
            return tmp.textContent || tmp.innerText || "";
        },

        /**
         * Returns self description string
         *
         * @return {string|null} The self description
         */
        _getSelfDescription: function() {
            return this.isValid() && this.hasText() ? `Text: ${this._stripHtmlText()}` : null;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/textWidget/TextWidgetModelEditorMixin.js